import React from "react";

/**
 * Brand logo block — the AI-generated butterfly-thyroid mark + brand text.
 * Used in headers/footers across blog, landing, dashboard, results pages.
 *
 * Variants:
 *   "header"  — default, ~36×36 px logo + bold title
 *   "footer"  — slightly smaller, ~32×32 px
 *   "compact" — icon only (no text)
 */
export const BrandLogo = ({ variant = "header", title = "Kilpnäärme Kliinik", className = "", showText = true }) => {
  const sizes = {
    header: { wrap: "w-9 h-9", img: "w-9 h-9", text: "text-xl" },
    footer: { wrap: "w-8 h-8", img: "w-8 h-8", text: "text-base" },
    compact: { wrap: "w-9 h-9", img: "w-9 h-9", text: "text-xl" },
  };
  const s = sizes[variant] || sizes.header;
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <span className={`${s.wrap} rounded-xl overflow-hidden flex items-center justify-center`} style={{ background: "#ffffff" }}>
        <img
          src="/brand/logo.webp"
          alt={title}
          width="64"
          height="64"
          className={`${s.img} object-contain`}
          loading="lazy"
          decoding="async"
        />
      </span>
      {showText && variant !== "compact" && (
        <span className={`${s.text} font-bold tracking-tight`} style={{ color: "#00658D" }}>
          {title}
        </span>
      )}
    </span>
  );
};

export default BrandLogo;
